/* Importing necessary libraries and hooks */
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

/* MUI components */
// import { Tooltip } from "@mui/material";

/* Supreme Edits context */
// import { useSupremeEditsPlayer } from "../../contexts/SupremeEditsContext.jsx"; // Import custom player context
// import { useLoggedUser } from "../../contexts/LoggedUserContext.jsx";

/* Custom utils */
// import showToast from "../../utils/toastNotifications.js";

/* Importing assets */
// import PlaylistIcon from "../../assets/icons/track-row/track.svg";
import ShowListIcon from "../../assets/icons/track-row/add-to.svg";
import HideListIcon from "../../assets/icons/track-row/hide-list.svg";
// import LinkIcon from "../../assets/icons/track-row/link.svg";
// import OptionsIcon from "../../assets/icons/track-row/options-icon.svg";
// import ArrowDownIcon from "../../assets/icons/arrow-down.svg";

/* Importing components */
// import DownloadButton from "../Common/DownloadButton.jsx";
// import InfoPopup from "../Popups/InfoPopup.jsx";
// import PlayButton from "../Track/PlayButton.jsx";
// import OptionsMenu from "../Popups/OptionsMenuPopup.jsx";
// import SimilarTrackPopup from "../Popups/SimilarTrackPopup.jsx";
import CustomButton from "../../components/Buttons/CustomButton";
import InfoPopup from "../Popups/InfoPopup";

/* Importing constants */
// import { useThunk } from "../../hooks/useThunk.js";
// import {
//   fetchAllTracks,
//   fetchMixables,
//   updateQueue,
// } from "../../store/index.js";
// import { useDispatch } from "react-redux";
// import { getCompatibleKeys } from "../../utils/camelotKeyUtils.js";

const fallbackImage = "https://via.placeholder.com/200x200.png?text=No+Cover";

const TrackRow = ({
  trackStrength,
  trackMetadata,
  trackData,
  remixMetadata,
  children,
  number,
  onLinkClick,
  playlistTracks,
  thisPlaylistName,
  playIndex,
  openedTrack,
  setOpenedTrack,
  onViewDetails,
  scrollContainerRef,
  isManipulated = false,
  onDelete,
  rowIndex
}) => {
  // State to manage the visibility and rendering of child components
  const [shouldRenderChildren, setShouldRenderChildren] = useState(false);
  const [showChildren, setShowChildren] = useState(false);

  // State to manage border highlight visibility
  const [showBorder, setShowBorder] = useState(false);

  useEffect(() => {
    if (
      openedTrack &&
      openedTrack.trackId === trackMetadata.trackId &&
      openedTrack.remixId === remixMetadata.id
    ) {
      console.log("Opened track".openedTrack);

      setShouldRenderChildren(true);
      setTimeout(() => setShowChildren(true), 100);
    } else {
      setShowChildren(false);
      setTimeout(() => setShouldRenderChildren(false), 500);
    }
  }, [openedTrack]);


  // Renders a list of artists with clickable links
  const renderArtists = (artists, prefix = "", keyPrefix = "") => {
    if (!artists) return null;
    const list = Array.isArray(artists) ? artists : [artists];
    if (list.length === 0) return null;

    return (
      <>
        {prefix && <span className="ml-1">{prefix}</span>}
        {list.map((artist, idx) => (
          <span
            key={`${keyPrefix}-${idx}`}
            // onClick={() => handleArtistClick(artist)}
            className="ml-0"
          >
            <span>{artist}</span>
            {idx < list.length - 1
              ? idx === list.length - 2
                ? " & "
                : ", "
              : ""}
          </span>
        ))}
      </>
    );
  };

  const isEven = rowIndex % 2 === 0;
  console.log("rowIndex", remixMetadata);

  return (
    <article className="min-h-[76px] md:min-h-[68px] relative group/track-row w-full h-fit flex flex-col justify-center items-center rounded-lg bg-transparent transition-all duration-500 ease-in-out animate-opacity">
      <div className="relative flex flex-col w-full h-full justify-center items-center p-[1px]">
        {/* Wrapper for border highlight */}
        <div
          className={`${
            showBorder
              ? "border-gradient opacity-100"
              : "bg-transparent p-[1px] opacity-0",
            isEven ? "bg-[#191919]" : "bg-[#1E1E1E]"
          } transition-opacity duration-500 animate-opacity-scale absolute top-0 max-h-[68px] w-full h-full z-0`}
        />

        {/* Track Row Container */}
        <div
          className={`relative z-10 flex flex-row w-full h-[66px] px-2 pr-3 sm:pr-5 sm:px-4 py-[14px] md:py-[10px] content-center justify-center items-center gap-3 sm:gap-4 lg:gap-3 xl:gap-5 rounded-lg ${
            showBorder ? "bg-[#121517]" : ""
          }`}
        >
          <div className="w-8 flex justify-end items-center">
            <p className="group-hover:opacity-0 delay-200 transition-all duration-300 opacity-100 track-number text-transparent text-[30px] sm:text-[36px] md:text-[40px] leading-8 font-black text-right">
              {number || 1}
            </p>
          </div>

          {/* Track and remix information */}
          <div className="track-info flex flex-1 flex-col gap-0 justify-start content-center items-start overflow-hidden max-w-full w-[min(200px,100%)]">
            <div className="w-full block">
              <p className="w-full truncate text-tertiary text-xs">
                {renderArtists(trackMetadata?.artists, "", "main")}
                {remixMetadata?.featuredArtists &&
                  renderArtists(
                    remixMetadata?.featuredArtists,
                    "ft. ",
                    "featured"
                  )}
              </p>
            </div>
            <p
              className="flex flex-col md:flex-row gap-0 text-secondary font-semibold text-sm whitespace-nowrap overflow-hidden max-w-full transition-opacity  "
            >
              {/* Track Title */}
              <span className="whitespace-nowrap overflow-hidden font-normal truncate">
                {trackMetadata?.trackTitle}
              </span>

              {/* Edit Title: inline on md+, stacked below on sm */}
              {remixMetadata?.editTitle && (
                <span className="text-tertiary whitespace-nowrap overflow-hidden font-normal truncate md:ml-1">
                  ({remixMetadata.editTitle})
                </span>
              )}
            </p>
          </div>

          {/* Metadata and control buttons */}
          <div className="w-fit flex flex-row gap-5 lg:gap-3 xl:gap-5 items-center justify-between">
            
            <div
              className="h-[18px] w-[18px] ms-[2px] relative cursor-pointer"
              // ref={iconRef}
            >
              {/* <InfoPopup
                // iconRef={iconRef}
                trackStrength={trackStrength}
                genre={remixMetadata?.genre}
                tags={remixMetadata?.tags}
                date={remixMetadata?.releaseDate}
              /> */}
              {trackData.isManipulated === false ? (
                  <span className="">{trackData.totalDownloads}</span>
              ) : null}
            </div>
          </div>

          {isManipulated ? (
            <CustomButton
              onClick={onDelete}
              className="flex items-center justify-center gap-2 px-4 py-1 border border-[#C00707] text-[#C00707] rounded-[15px] text-xs font-normal w-[90px] hover:bg-[#330000] transition font-inter"
            >
              Delete
            </CustomButton>
          ) : (
            <div className="w-[90px] h-[28px]" />
          )}
        </div>
      </div>

      {/* Collapsible child section */}
      {shouldRenderChildren && (
        <div
          className={`relative w-full transition-all duration-500 ease-in-out ${
            showChildren ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          <div className="flex flex-col justify-center flex-1 gap-[1px] mt-[2px]"></div>
        </div>
      )}
    </article>
  );
};
export default TrackRow;
